module.exports = __webpack_public_path__ + "assets/bg_steps_icn@1x.6a206d76.svg";